export default {
  LearnRecords_date: 'YYYY-MM-DD',
}
